/* Escolha de tamanho obrigatoria na pagina de produto.
   A trava e no atributo disabled do botao, nao so no visual — assim nao passa
   por teclado nem por submit do form. */
(function () {
  function liga(raiz) {
    var caixa = raiz.querySelector('[data-tam]');
    if (!caixa) return;
    var form = raiz.querySelector('.pdp-form') || caixa.closest('form');
    if (!form) return;

    var botao = form.querySelector('[data-comprar]');
    var disponivel = !botao || botao.getAttribute('data-available') !== 'false';
    var propSis = form.querySelector('[data-prop-sis]');
    var propNum = form.querySelector('[data-prop-num]');
    var aviso = caixa.querySelector('[data-aviso]');
    var sistema = (caixa.querySelector('.tam__sis.is-on') || {}).dataset
      ? caixa.querySelector('.tam__sis.is-on').dataset.sis : 'US';
    var numero = null;

    function atualiza() {
      var pronto = disponivel && !!numero;
      if (botao) botao.disabled = !pronto;
      if (propSis) propSis.value = pronto ? sistema : '';
      if (propNum) propNum.value = pronto ? numero : '';
      if (aviso) aviso.hidden = pronto;
    }

    caixa.querySelectorAll('.tam__sis').forEach(function (b) {
      b.addEventListener('click', function () {
        caixa.querySelectorAll('.tam__sis').forEach(function (o) { o.classList.remove('is-on'); });
        b.classList.add('is-on');
        sistema = b.dataset.sis;
        caixa.querySelectorAll('[data-grade]').forEach(function (g) {
          g.hidden = g.dataset.grade !== sistema;
        });
        // trocar de sistema zera a escolha: o 7 de US nao e o 7 de EUR
        numero = null;
        caixa.querySelectorAll('.tam__num').forEach(function (o) { o.classList.remove('is-on'); });
        atualiza();
      });
    });

    caixa.querySelectorAll('.tam__num').forEach(function (b) {
      b.addEventListener('click', function () {
        caixa.querySelectorAll('.tam__num').forEach(function (o) { o.classList.remove('is-on'); });
        b.classList.add('is-on');
        numero = b.dataset.num;
        atualiza();
      });
    });

    form.addEventListener('submit', function (e) {
      if (!disponivel || !numero) {
        e.preventDefault();
        if (aviso) aviso.hidden = !disponivel;
        caixa.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    atualiza();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { liga(document); });
  } else {
    liga(document);
  }
})();
